export const MENU_ROUTE = "/{service_company_slug}/menu/"
